import * as React from 'react';

import { IconX } from '@tabler/icons-react';

export const CompactDialogContainer = ({ children }: { children: React.ReactNode }) => (
  <div
    className="
      relative
      w-[362px] rounded-[6px]
      border border-[#9a1698] bg-gray-950 px-[10px]
      pb-[10px] pt-[5px] text-left text-[12px] font-medium
      leading-[16px] tracking-[0] text-white shadow-[0_16px_24px_rgba(13,13,13,0.9),0_0_1px_#0d0d0d] [font-family:Heebo,sans-serif]
    "
  >
    {children}
  </div>
);

export const CloseButton = ({ onClick }: { onClick: () => void }) => {
  return (
    <div className="absolute right-0 top-0 cursor-pointer" onClick={onClick}>
      <IconX />
    </div>
  );
};
